import React from 'react';
import InvoiceDraftDetail from '../modules/invoices/components/InvoiceDraftDetail';
export default function PurchaseInvoiceDraftDetail() { return <InvoiceDraftDetail direction="PURCHASE" />; }
